<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'notice',
      key: 'id',
      url: {
        get: '/admin/system/notice',
        add: '/admin/system/notice',
        edit: '/admin/system/notice',
      },
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        { label: '公告标题', name: 'noticeTitle', value: '', type: 'input',width:'400px', rules: [{ required: true, trigger: 'blur' }] },
        { label: '公告内容', name: 'noticeContent', value: '', type: 'textarea',width:'400px'},
        {
          label: "类型",
          name: "noticeType",
          value: 2,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "通知",
            },
            {
              value: 2,
              name: "公告",
            },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "是否置顶",
          name: "topping",
          value: 1,
          type: "select",
          dropList: [
            {
              value: 0,
              name: "不置顶",
            },
            {
              value: 1,
              name: "置顶",
            },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
      ],
      forms: {},
    }
  },
  created() {},
  methods: {
    // initData() {
    //   // 加载详情数据
    //   let id = this.kv
    //   $utils.api.load(`/admin/system/announcement/${id}`, {}).then((res) => {
    //     if (res && res.data) {
    //       this.forms = res.data
    //     }
    //   })
    // },
    // handleSubmit() {
    //   if (!this.action) {
    //     return true
    //   }
    //   let q = this.forms
    //   this.$refs.form.validate((valid) => {
    //     if (valid) {
    //       this.sloading = true
    //       $utils.api
    //         .load(`/admin/system/announcement`, q, this.action == 'edit' ? 'PUT' : 'POST')
    //         .then((res) => {
    //           this.sloading = false
    //           if (res.status) {
    //             $utils.toast.success('保存成功')
    //             $utils.url.go(-1)
    //           }
    //         })
    //         .catch((e) => {
    //           this.sloading = false
    //           $utils.toast.error('保存异常' + e.message)
    //         })
    //     }
    //   })
    // },
  },
}
</script>
